import { StoryblokComponent } from "@storyblok/react";
import FeaturedBottom from "@/components/FeaturedBottom";
import { useBlogContext } from "@/contexts/BlogContext";
// import { logger } from '@/lib/logger';

const BlogHomepageBulletproof = ({ content }: { content: any; allBlogPosts?: any[] | null }) => {
  const {
    isSearching,
    visiblePosts,
    hasMore,
    totalResults,
  } = useBlogContext();

  const {
    featured_top,
    featured_bottom,
    quote_form,
    accreditations_big,
  } = content;

  // logger.log(`visiblePosts` + JSON.stringify(visiblePosts, null, 2));

  return (
    <>
      <div className={`bg-light py-4 py-md-5 blog-featured-wrapper ${isSearching ? 'd-none' : ''}`}>
        <div className="container blog-featured">
          <div className="blog-grid">
            {Array.isArray(featured_top) &&
              featured_top.map((featuredItem: any) => {
                const content = featuredItem.content;

                if (content && Array.isArray(content.blog_details) && content.blog_details.length > 0) {
                  const blogDetail = content.blog_details[0];
                  const blogAuthor = content.blog_author[0];
                  const blogPost = content.hero_blog_post[0];

                  const reformattedBlok = {
                    _uid: blogDetail._uid,
                    component: "featured_top",
                    title: featuredItem.name,
                    slug: featured_top[0].slug,
                    description: blogPost.description,
                    date: blogDetail.date,
                    thumb: blogPost?.image?.filename || "",
                    topics: blogDetail.topics,
                    services: blogDetail.services,
                    author_name: blogAuthor?.name || "",
                    author_photo: blogAuthor?.content?.image?.filename || "",
                  };

                  return (
                    <StoryblokComponent
                      blok={reformattedBlok}
                      key={reformattedBlok._uid}
                    />
                  );
                }

                return null;
              })}

            {Array.isArray(featured_bottom) &&
              featured_bottom.flatMap((selector: any) => {
                if (selector.component !== "blog_selector" || !Array.isArray(selector.select_story)) {
                  return [];
                }

                return selector.select_story.map((story: any, index: number) => {  // Add index parameter
                  const content = story.content;

                  if (!content || !Array.isArray(content.blog_details) || content.blog_details.length === 0) {
                    return null;
                  }

                  const blogDetail = content.blog_details[0];
                  const blogAuthor = content.blog_author?.[0] || {};
                  const blogPost = content.hero_blog_post[0];

                  const reformattedBlok = {
                    _uid: `featured-bottom-${blogDetail._uid}-${index}`, // Ensure unique key by combining _uid and index
                    component: "featured_bottom",
                    title: story.name,
                    thumb: blogPost?.image?.filename || "",
                    topics: blogDetail.topics,
                    slug: story.slug || "",
                    author_name: blogAuthor?.name || "",
                    author_photo: blogAuthor?.content?.image?.filename || "",
                  };

                  return (
                    <StoryblokComponent
                      blok={reformattedBlok}
                      key={reformattedBlok._uid}
                    />
                  );
                });
              })}
          </div>
        </div>
      </div>

      <div className={`py-4 py-md-5 blog-results ${isSearching ? 'blog-searching' : ''}`} id="blog-results">
        <div className="container blog-latest">
          <h2
            className="text-center mb-5 text-dark"
            id="blog-title"
            data-default-title="Latest from the blog"
          >
            {isSearching
              ? `Search results (${totalResults === 1 ? '1 result' : totalResults + ' results'})`
              : 'Latest from the blog'
            }
          </h2>

          <div className="blog-grid blog-main">
            {visiblePosts.length > 0 ? (
              visiblePosts.map((blogPost: any, index: number) => {
                // Extract relevant data from the blog post
                const { slug, name, content } = blogPost;

                if (!content || !Array.isArray(content.blog_details) || content.blog_details.length === 0) {
                  return null;
                }

                const blogDetail = content.blog_details[0];
                const blogAuthor = content.blog_author?.[0] || {};
                const heroBlogPost = content.hero_blog_post?.[0] || {};
                const blogTitle = name || blogDetail.title || "";
                const blogTopics = blogDetail.topics || "";

                const reformattedBlok = {
                  _uid: `visible-post-${blogDetail._uid}-${index}`,
                  component: "featured_bottom",
                  title: blogTitle,
                  thumb: heroBlogPost?.image?.filename || blogDetail.thumb?.filename || content.metatags?.og_image || "",
                  topics: blogTopics,
                  slug: slug || "",
                  author_name: blogAuthor?.name || "",
                  author_photo: blogAuthor?.content?.image?.filename || "",
                  data_filter: blogTitle, // For filtering
                  data_topic: blogTopics?.toLowerCase()?.replace(/\s/g, '-'), // For topic filtering
                };

                return (
                  <FeaturedBottom
                    blok={reformattedBlok}
                    key={reformattedBlok._uid}
                  />
                );
              })
            ) : (
              <div className="blog-search-noresults text-center p-4 bg-light container rounded-2">
                <svg className="icon icon-3x mx-auto icon-no-results d-block text-light mb-3" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                  <line x1="12" x2="12" y1="9" y2="13"></line>
                  <line x1="12" x2="12.01" y1="17" y2="17"></line>
                </svg>
                Sorry, there were no results.
              </div>
            )}
          </div>

          {hasMore && (
            <div
              id="load-more-trigger"
              className="text-center mt-4 p-3"
              style={{ opacity: 0.01 }}
            >
              Loading more...
            </div>
          )}
        </div>
      </div>

      {Array.isArray(quote_form) &&
        quote_form.map((blok: any) => (
          <StoryblokComponent
            blok={blok}
            key={blok._uid || `${Math.random()}`}
          />
        ))}

      {Array.isArray(accreditations_big) &&
        accreditations_big.map((item: any) => {
          const content = item.content;
          return content ? (
            <StoryblokComponent
              blok={content}
              key={content._uid || `${Math.random()}`}
            />
          ) : null;
        })}
    </>
  );
};

export default BlogHomepageBulletproof;